import { Wrench, Phone, MapPin, NavigationArrow } from "@phosphor-icons/react";
import { BUSINESS } from "@/lib/business";

export const Footer = () => (
  <footer className="bg-[#0a0a0a] text-white mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-[#3DA935] flex items-center justify-center"><Wrench size={22} weight="fill" color="#0a0a0a" /></div>
          <div className="font-heading text-2xl tracking-tight">{BUSINESS.name.toUpperCase()}</div>
        </div>
        <p className="text-zinc-400 text-sm max-w-md leading-relaxed">
          Truck parts and tires for every make on the road — new, used and rebuilt.
          Call us or request a quote and we'll help you find exactly what you need.
        </p>
      </div>
      <div>
        <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mb-4">Contact</h4>
        <ul className="space-y-3 text-sm text-zinc-300">
          <li><a href={`tel:${BUSINESS.phoneTel}`} className="flex items-center gap-2 hover:text-[#3DA935] transition-colors"><Phone size={16} className="text-[#3DA935]" /> {BUSINESS.phoneDisplay}</a></li>
          <li className="flex items-start gap-2"><MapPin size={16} className="text-[#3DA935] mt-0.5 shrink-0" /> {BUSINESS.address}</li>
          <li><a href={BUSINESS.mapsDirections} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#3DA935] transition-colors"><NavigationArrow size={16} className="text-[#3DA935]" /> Get Directions</a></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mb-4">Hours</h4>
        <ul className="space-y-2 text-sm text-zinc-300">
          <li>Mon–Fri: 8am – 6pm</li>
          <li>Sat: 9am – 3pm</li>
          <li>Sun: Closed</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-zinc-800 py-6 text-center text-xs text-zinc-500 uppercase tracking-widest">
      © {new Date().getFullYear()} {BUSINESS.name}
    </div>
  </footer>
);

export default Footer;
